<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>
        <section class="dp-right lsm-page">
            <header class="lsm-page-head">
                <h2 class="lsm-page-title">画像基础信息管理</h2>
                <div class="lsm-page-actions" v-if="DepartmentId > 0">
                    <el-button v-if="!editing" type="primary" size="small" @click="handleEdit">编辑</el-button>
                    <el-button v-if="editing" type="primary" size="small" @click="handleSave" :loading="saving">保存配置</el-button>
                    <el-button v-if="editing" size="small" @click="handleCancel">取消</el-button>
                </div>
            </header>

            <div class="lsm-page-body">
                <div class="elegant-card" v-if="DepartmentId > 0">
                    <el-form :model="formData" label-width="120px" class="elegant-form">
                        <!-- 基本设置 -->
                        <h3 class="section-title">基本设置</h3>
                        <el-form-item label="大屏名称：">
                            <el-input v-model="formData.screenName" placeholder="请输入大屏名称，例如：哲现大脑" class="custom-input"
                                :disabled="!editing"></el-input>
                        </el-form-item>

                        <el-form-item label="校训：">
                            <el-input v-model="formData.schoolMotto" placeholder="请输入校训" class="custom-input"
                                :disabled="!editing"></el-input>
                        </el-form-item>

                        <el-divider class="elegant-divider"></el-divider>

                        <!-- 组织架构 -->
                        <h3 class="section-title">组织架构</h3>
                        <el-form-item label="架构图：" class="full-width-item">
                            <div class="upload-wrapper">
                                <el-upload class="custom-uploader" ref="orgUpload" action="#" :auto-upload="false"
                                    :show-file-list="false" :on-change="handleOrgChange"
                                    accept=".png, .jpg, .jpeg, .svg, .gif"
                                    style="width:213px;height:120px;display:flex;align-items:center;justify-content:center;overflow:hidden;">
                                    <img v-if="deferredImageDisplay('orgChart', formData.orgImage)" :src="getIconPath(deferredImageDisplay('orgChart', formData.orgImage))"
                                        class="preview-img"
                                        @click.stop="editing ? triggerOrgUpload() : openPreview(formData.orgImage)">
                                    <i v-else-if="editing" class="el-icon-plus uploader-icon"></i>
                                    <i v-else class="el-icon-picture-outline" style="font-size:28px;color:#c0ccda;"></i>
                                </el-upload>
                                <div class="upload-tip">支持 jpg、jpeg、png、svg 格式，建议比例 16:9</div>
                            </div>
                        </el-form-item>

                        <el-divider class="elegant-divider"></el-divider>

                        <!-- 学校图片 -->
                        <h3 class="section-title">学校图片</h3>
                        <el-form-item label="校园图集：" class="full-width-item gallery-item">
                            <div class="gallery-grid">
                                <div class="gallery-card" v-for="(img, index) in formData.schoolImages" :key="index">
                                    <img v-if="img.url" :src="img.url.indexOf('blob:') === 0 ? img.url : getIconPath(img.url)" class="gallery-img"
                                        @click.stop="openPreview(img.url)">
                                    <div v-else class="empty-gallery">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                    <div class="gallery-actions" v-if="img.url && editing">
                                        <i class="el-icon-delete delete-icon" @click.stop="removeGalleryImg(index)"></i>
                                    </div>
                                </div>
                                <!-- 添加按钮 -->
                                <el-upload v-if="editing && formData.schoolImages.length < 8" class="gallery-uploader"
                                    action="#" :auto-upload="false" :show-file-list="false"
                                    :on-change="handleGalleryChange"
                                    accept=".png, .jpg, .jpeg, .svg, .gif">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                            <div class="upload-tip">支持 jpg、jpeg、png、svg 格式，最多上传 8 张展示图片</div>
                        </el-form-item>

                        <el-divider class="elegant-divider"></el-divider>

                        <!-- 学校介绍 -->
                        <h3 class="section-title">学校简介</h3>
                        <el-form-item label="主文本：" class="full-width-item" style="margin-bottom: 0;">
                            <el-input type="textarea" v-model="formData.schoolIntro" :rows="5"
                                placeholder="请输入学校介绍文字..." class="custom-textarea" :disabled="!editing">
                            </el-input>
                        </el-form-item>

                        <!-- 基础数据与专属场馆 -->
                        <el-divider class="elegant-divider"></el-divider>
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="本区标准师生比：" label-width="140px">
                                    <el-input v-model="formData.schoolStudentTeacherRatio"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="教学楼：" label-width="120px">
                                    <el-input v-model="formData.teachingBuildingCount" placeholder="数量"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="人工智能教室：" label-width="120px">
                                    <el-input v-model="formData.aiChemistryLabCount" placeholder="数量"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="科学实验室：" label-width="140px">
                                    <el-input v-model="formData.scienceLabCount" placeholder="数量"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="艺术空间：" label-width="120px">
                                    <el-input v-model="formData.artSpaceCount" placeholder="数量"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="约劳耕园：" label-width="120px">
                                    <el-input v-model="formData.modelFarmCount" placeholder="数量"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="运动场/馆：" label-width="140px">
                                    <el-input v-model="formData.stadiumCount" placeholder="数量"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="报告厅：" label-width="120px">
                                    <el-input v-model="formData.lectureHallCount" placeholder="数量"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="校园食堂：" label-width="120px">
                                    <el-input v-model="formData.cafeteriaCount" placeholder="数量"
                                        :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>

                        <!-- 成长树文字展示 -->
                        <el-row :gutter="24">
                            <el-col :span="24">
                                <el-form-item label="成长树文字展示：" label-width="140px" style="margin-bottom: 0px;">
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label-width="140px">
                                    <el-input v-model="formData.growthTreeCharacter" :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label-width="140px">
                                    <el-input v-model="formData.growthTreeWisdom" :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label-width="140px">
                                    <el-input v-model="formData.growthTreeHealth" :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label-width="140px">
                                    <el-input v-model="formData.growthTreeArt" :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label-width="140px">
                                    <el-input v-model="formData.growthTreeLabor" :disabled="!editing"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </el-form>
                </div>

                <!-- 未选择部门时的提示 -->
                <div v-else class="lsm-empty-tip">
                    <p>请选择左侧的学校或部门来查看和配置大屏基础信息</p>
                </div>
            </div>
            <!-- 预览弹窗放在组件模板底部 -->
            <el-dialog :visible.sync="previewDialog" width="60%" :show-close="true" center>
                <img :src="getIconPath(previewSrc)" style="width:100%;height:auto;display:block;" />
            </el-dialog>
        </section>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane'
import { getComputerScreenConfig, saveComputerScreenConfig } from '../../api/modules/big-screen';
import { BaseApiUrl } from '../../api/base';
import { attachLocalAvatarFile, revokeLocalAvatarPreview, uploadPic } from '../../utils/ossMediaUpload'

export default {
    name: 'BasicInfoManage',
    components: { DepartmentPane },
    data() {
        return {
            DepartmentId: 0,
            saving: false,
            editing: false,
            BaseApiUrl: BaseApiUrl, // 网络前缀
            formData: {
                screenName: '',
                orgImage: '',
                schoolImages: [],
                schoolIntro: '',
                schoolStudentTeacherRatio: '',
                cafeteriaCount: '',
                teachingBuildingCount: '',
                aiChemistryLabCount: '',
                scienceLabCount: '',
                artSpaceCount: '',
                modelFarmCount: '',
                stadiumCount: '',
                lectureHallCount: '',
                growthTreeCharacter: '品德',
                growthTreeWisdom: '智慧',
                growthTreeHealth: '体质',
                growthTreeArt: '艺术',
                growthTreeLabor: '劳动',
                schoolMotto: ''
            }
            ,
            previewDialog: false,
            previewSrc: ''
        }
    },
    created() {
        // 默认进入为只读模式
        this.editing = false;
    },
    computed: {
        uploadHeaders() {
            let token = window.localStorage.Token || (this.$store && this.$store.state.token) || '';
            return {
                Authorization: 'Bearer ' + token
            };
        }
    },
    methods: {
        treeNodeClick(data, node, component) {
            this.DepartmentId = data.value;
            this.loadConfig();
        },
        async loadConfig() {
            if (!this.DepartmentId) return;
            try {
                const res = await getComputerScreenConfig({ departmentId: this.DepartmentId });
                console.log(res);
                if (res.data.success && res.data.response) {
                    const data = res.data.response;
                    this.formData.screenName = data.ComputerScreenName || '';
                    this.formData.schoolIntro = data.SchoolIntroduction || '';
                    this.formData.orgImage = data.OrganizationChart || '';
                    this.deferredImageInit('orgChart', this.formData.orgImage);
                    this.formData.schoolStudentTeacherRatio = data.SchoolStudentTeacherRatio || '';
                    this.formData.cafeteriaCount = data.CafeteriaCount || '';
                    this.formData.teachingBuildingCount = data.TeachingBuildingCount || '';
                    this.formData.aiChemistryLabCount = data.AIChemistryLabCount || '';
                    this.formData.scienceLabCount = data.ScienceLabCount || '';
                    this.formData.artSpaceCount = data.ArtSpaceCount || '';
                    this.formData.modelFarmCount = data.ModelFarmCount || '';
                    this.formData.stadiumCount = data.StadiumCount || '';
                    this.formData.lectureHallCount = data.LectureHallCount || '';
                    this.formData.growthTreeCharacter = data.GrowthTreeCharacter || '品德';
                    this.formData.growthTreeWisdom = data.GrowthTreeWisdom || '智慧';
                    this.formData.growthTreeHealth = data.GrowthTreeHealth || '体质';
                    this.formData.growthTreeArt = data.GrowthTreeArt || '艺术';
                    this.formData.growthTreeLabor = data.GrowthTreeLabor || '劳动';
                    this.formData.schoolMotto = data.SchoolMotto || '';

                    if (data.SchoolImages) {
                        try {
                            this.formData.schoolImages = JSON.parse(data.SchoolImages);
                        } catch (e) {
                            // 如果不是JSON，尝试逗号分割
                            this.formData.schoolImages = data.SchoolImages.split(',').filter(url => url).map(url => ({ url }));
                        }
                    } else {
                        this.formData.schoolImages = [];
                    }
                    // 加载后保持只读状态，用户需要点击 编辑 才能修改
                    this.editing = false;
                }
            } catch (error) {
                console.error("加载配置失败", error);
                this.$message.error("加载配置失败");
            }
        },
        handleEdit() {
            if (!this.DepartmentId) {
                this.$message.warning('请先选择左侧的学校或部门！');
                return;
            }
            this.editing = true;
        },
        async handleSave() {
            if (!this.DepartmentId) {
                this.$message.warning("请先选择左侧的学校或部门！");
                return;
            }
            this.saving = true;
            try {
                const orgImage = await this.deferredImageEnsure('orgChart', { foo: 'organizationChart', currentUrl: this.formData.orgImage })
                const galleryUrls = []
                for (let i = 0; i < (this.formData.schoolImages || []).length; i++) {
                    const img = this.formData.schoolImages[i]
                    if (img.raw) {
                        const { url } = await uploadPic(img.raw, this, 'schoolImages')
                        galleryUrls.push({ url })
                    } else if (img.url) {
                        galleryUrls.push({ url: img.url })
                    }
                }
                const params = {
                    schoolId: this.DepartmentId,
                    computerScreenName: this.formData.screenName || '',
                    schoolImages: JSON.stringify(galleryUrls),
                    schoolIntroduction: this.formData.schoolIntro || '',
                    organizationChart: orgImage || '',
                    schoolStudentTeacherRatio: this.formData.schoolStudentTeacherRatio || '',
                    teachingBuildingCount: this.formData.teachingBuildingCount || '',
                    aiChemistryLabCount: this.formData.aiChemistryLabCount || '',
                    cafeteriaCount: this.formData.cafeteriaCount || '',
                    scienceLabCount: this.formData.scienceLabCount || '',
                    artSpaceCount: this.formData.artSpaceCount || '',
                    modelFarmCount: this.formData.modelFarmCount || '',
                    stadiumCount: this.formData.stadiumCount || '',
                    lectureHallCount: this.formData.lectureHallCount || '',
                    growthTreeCharacter: this.formData.growthTreeCharacter || '品德',
                    growthTreeWisdom: this.formData.growthTreeWisdom || '智慧',
                    growthTreeHealth: this.formData.growthTreeHealth || '体质',
                    growthTreeArt: this.formData.growthTreeArt || '艺术',
                    growthTreeLabor: this.formData.growthTreeLabor || '劳动',
                    schoolMotto: this.formData.schoolMotto || ''
                };
                const res = await saveComputerScreenConfig(params);
                if (res.data.success) {
                    this.$message.success(res.data.msg || '基础配置保存成功');
                    // 保存成功后回到只读模式
                    this.editing = false;
                } else {
                    this.$message.error(res.data.msg || '保存失败');
                }
            } catch (error) {
                console.error("保存失败", error);
                this.$message.error('保存失败，网络或服务器异常');
            } finally {
                this.saving = false;
            }
        },
        async handleCancel() {
            // 取消编辑，重新加载配置以恢复为最新已保存状态
            await this.loadConfig();
            this.editing = false;
        },
        beforeUpload(file) {
            const isImage = file.type.startsWith('image/');
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isImage) {
                this.$message.error('只能上传图片格式的文件!');
            }
            if (!isLt5M) {
                this.$message.error('图片大小不能超过 5MB!');
            }
            return isImage && isLt5M;
        },
        // 处理图片路径，将纯路径增加接口域名补全
        getIconPath(path) {
            if (!path) return '';
            if (path.startsWith('http')) {
                return path;
            }

            // 防御纯斜杠，确保拼接出带域名的完整网络路径
            let pureFileName = path;
            if (!pureFileName.startsWith('/')) {
                pureFileName = '/' + pureFileName;
            }

            return this.$resolveImageSrc(pureFileName);
        },
        handleOrgChange(file) {
            if (!file || !file.raw || !this.editing) return
            if (!this.beforeUpload(file.raw)) return
            this.deferredImageChange('orgChart', file, { foo: 'organizationChart', savedUrl: this.formData.orgImage })
        },
        handleGalleryChange(file) {
            if (!file || !file.raw) return
            if (!this.beforeUpload(file.raw)) return
            const local = attachLocalAvatarFile(file.raw)
            this.formData.schoolImages.push({ url: local.pendingAvatarPreviewUrl, raw: local.pendingAvatarFile })
        },
        removeGalleryImg(index) {
            this.$confirm('确认删除该图片?', '提示', {
                type: 'warning'
            }).then(() => {
                const img = this.formData.schoolImages[index]
                if (img && img.url && String(img.url).indexOf('blob:') === 0) {
                    revokeLocalAvatarPreview(img.url)
                }
                this.formData.schoolImages.splice(index, 1);
            }).catch(() => { });
        }
        ,
        openPreview(src) {
            if (!src) return;
            this.previewSrc = src;
            this.previewDialog = true;
        }
        ,
        triggerOrgUpload() {
            // 触发 el-upload 内部的 file input 点击以打开文件选择
            try {
                const up = this.$refs.orgUpload;
                if (!up) return;
                // Element UI 的 el-upload 组件根元素包含 input[type=file]
                const input = up.$el.querySelector('input[type=file]');
                if (input) input.click();
            } catch (e) {
                console.error('triggerOrgUpload failed', e);
            }
        }
    }
}
</script>

<style src="../../style/large-screen-manage.css"></style>
<style scoped>
/* =========== 审美规范注入 =========== */
.elegant-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 16px 20px 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    border: 1px solid #eef0f6;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #3b4256;
    margin-bottom: 8px;
    margin-top: 0;
}

.elegant-divider {
    margin: 8px 0;
    background-color: #eef0f6;
}

.elegant-form /deep/ .el-form-item {
    margin-bottom: 12px;
}

/* 表单定制化 */
/* 使得宽屏幕下输入框不用太长 */
.custom-input {
    max-width: 400px;
}

.custom-input /deep/ .el-input__inner {
    border-radius: 8px;
    border-color: #dcdfe6;
    transition: all 0.3s;
}

.custom-input /deep/ .el-input__inner:focus {
    border-color: var(--btn-primary, #2563eb);
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.custom-textarea {
    max-width: 800px;
}

.custom-textarea /deep/ .el-textarea__inner {
    border-radius: 8px;
    padding: 12px 16px;
    line-height: 1.6;
}

/* 上传区域（组织架构大图） */
.upload-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.custom-uploader /deep/ .el-upload {
    border: 1px dashed #c0ccda;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-color: #fafbfc;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 213px;
    height: 120px;
    /* 16:9 approximated */
}

.custom-uploader /deep/ .el-upload:hover {
    border-color: var(--btn-primary, #2563eb);
    background-color: #f1f6ff;
}

.uploader-icon {
    font-size: 28px;
    color: #8c939d;
}

.preview-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.upload-tip {
    font-size: 12px;
    color: #909399;
}

/* 照片墙网格 (使用 CSS Grid 达到完美的对其) */
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 128px);
    gap: 16px;
    margin-bottom: 12px;
}

.gallery-card {
    width: 128px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #ebedf2;
}

.gallery-img,
.empty-gallery {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
}

.gallery-img {
    cursor: pointer;
}

.empty-gallery {
    background: #f8f9fb;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #c0ccda;
}

.gallery-card:hover .gallery-img {
    transform: scale(1.05);
}

.gallery-actions {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 10;
}

.gallery-card:hover .gallery-actions {
    opacity: 1;
}

.delete-icon {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    background: rgba(245, 108, 108, 0.8);
    transition: all 0.2s;
}

.delete-icon:hover {
    background: #f56c6c;
    transform: scale(1.1);
}

.gallery-uploader /deep/ .el-upload {
    width: 128px;
    height: 80px;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #fafbfc;
    transition: all 0.3s;
}

.gallery-uploader /deep/ .el-upload:hover {
    border-color: var(--btn-primary, #2563eb);
    background-color: #f1f6ff;
    color: var(--btn-primary, #2563eb);
}

.no-department-tip {
    display: none;
}

/* 预览样式 */
.preview-img {
    cursor: pointer;
    max-width: 100%;
    max-height: 100%;
}
</style>
